import { useMemo } from "react";

import { IdpGroupRolesBulkActionsPayload } from "./types";
import useDeleteIdpGroupRolesBulkAction from "./useDeleteIdpGroupRolesBulkAction";

const useIdpGroupRolesBulkActions = (): IdpGroupRolesBulkActionsPayload[] => {
  const confirmDeleteIdpGroupRolesBulkAction = useDeleteIdpGroupRolesBulkAction();

  return useMemo(
    () => [confirmDeleteIdpGroupRolesBulkAction],
    [confirmDeleteIdpGroupRolesBulkAction]
  );
};

export default useIdpGroupRolesBulkActions;
